import h from 'hyperscript';
import Control from 'ol/control/Control';
import { unByKey } from 'ol/Observable';

import { context } from 'cadenza/map/context';
import { roundScale } from 'cadenza/map/round-scale';

import i18n from './messages.properties';

export class ScaleInput extends Control {

  _input;
  _readonlyValue;
  _viewChangeResolutionEventKey;

  constructor (options) {
    const container = h('div.d-scale-input.ol-unselectable.ol-control');
    super(Object.assign(options, { element: container }));

    if (options.readonly) {
      this._readonlyValue = h('span.d-scale-value');
    } else {
      this._input = h('input#d-scale-input-field', {
        type: 'text',
        onchange: () => this._updateMap(),
        onkeydown: event => { // IE does not trigger a change event on enter
          if (event.key === 'Enter') {
            event.preventDefault();
            this._updateMap();
          }
        }
      });
    }

    container.append(
      h(
        'label',
        { htmlFor: 'd-scale-input-field' },
        i18n('scaleInput.label') + ' 1 :'
      ),
      options.readonly ? this._readonlyValue : this._input
    );
  }

  setMap (map) {
    super.setMap(map);
    this._updateValue();
    unByKey(this._viewChangeResolutionEventKey);
    this._viewChangeResolutionEventKey = map.getView().on('change:resolution', () => this._updateValue());
  }

  _updateValue () {
    const mapContext = context(this.getMap());
    const scaleValue = formatScaleValue(roundScale(mapContext.mapScale, 2, 0));

    if (this._input) {
      this._input.value = scaleValue;
    } else {
      this._readonlyValue.textContent = ' ' + scaleValue;
    }
  }

  _updateMap () {
    const value = this._input.value;
    const scale = roundScale(parseNumber(value), 2, 0);
    if (!isNaN(scale)) {
      const mapContext = context(this.getMap());
      mapContext.mapScale = scale;
    }
    this._updateValue();
  }

}

/**
 * Parses a number from user input
 *
 * @param {string} inputString - number, optionally formatted (grouping separators - dots, raction separator - comma)
 * @return parsed value or NaN if not parseable
 */
function parseNumber (inputString) {
  return Number(inputString.replace(/\./g, '').replace(/,/, '.'));
}

/**
 * Formats the given scale value
 *
 * @param scaleValue - valid integer number
 * @return {string} formatted number where dots are used as a grouping separator
 */
function formatScaleValue (scaleValue) {
  // used fixed locale that uses dot as a grouping separator
  return Number(scaleValue).toLocaleString('de', { useGrouping: true, maximumFractionDigits: 0 });
}
